<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import { Payroll } from '@/types';
    import QueryKey from '@/enums/QueryKey';
    import AddEmployeeToPayrollForm from '@/components/salary/AddEmployeeToPayrollForm.vue';
    import { router } from '@inertiajs/vue3';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';

    const props = defineProps<{
        payroll: Payroll;
        disabled: boolean;
    }>();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        employee_id: null,
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.salary.payrolls.add-employee', { payroll: props.payroll.id })"
        :query-key="[QueryKey.PAYROLL, selectedCompanyId, props.payroll.id]"
        title="payrolls.add_employee_to_payroll.header"
        button-text="payrolls.other_buttons.add_employee_to_payroll"
        submit-text="payrolls.add_employee_to_payroll.add_employee"
        success-message="payrolls.edit.employee_added_to_payroll"
        :disabled="props.disabled"
    >
        <AddEmployeeToPayrollForm
            :form="form"
            :payroll="props.payroll"
        />
    </DialogForm>
</template>
